import { combineEpics } from 'redux-observable'
import { SendMessageEpic } from './SendMessageEpic.js'
import { RenderReportEpic } from './RenderReportEpic.js'

export const chatEpics = combineEpics(SendMessageEpic, RenderReportEpic)
